/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/naming-convention */
import { type useToast } from "@chakra-ui/react"
import { type UserProfileDataInterface } from "../../../components/commons/commonTypes"
import { getSavedUserDetails } from "../../../components/Menu/menu.support"
import { failForm, validateEmail } from "../signupNew/signup.support"
interface validateFormInterface {
  isValid: boolean
  message: string
}

export const ValidateForm = (
  form: HTMLFormElement | null,
  getModifiedUserDetails: UserProfileDataInterface,
  toast: ReturnType<typeof useToast>
): validateFormInterface => {
  const { new_email_address } = getModifiedUserDetails
  const savedUserDetails = getSavedUserDetails()
  if (new_email_address && new_email_address !== "") {
    const testEmail = validateEmail(new_email_address)
    if (!testEmail.isValid) {
      failForm(testEmail.message, toast)
      form?.new_email_address.focus()
      return {
        isValid: false,
        message: testEmail.message
      }
    }
  }
  // if (new_password && new_password === password) {
  //   form?.password.focus()
  //   failForm('New password cannot be the same as the old password', toast)
  //   return {
  //     isValid: false,
  //     message: 'Please enter your old passworddd'
  //   }
  // }
  // if (new_password && password) {
  //   form?.password.focus()
  //   failForm('Please enter your old password', toast)
  //   return {
  //     isValid: false,
  //     message: 'Please enter your old password'
  //   }
  // }

  // if (password && new_password) {
  //   failForm('Please enter your new password', toast)
  //   form?.new_password.focus()
  //   return {
  //     isValid: false,
  //     message: 'Please enter your new password'
  //   }
  // }
  // if (new_password && new_password !== '') {
  //   form?.new_password.focus()
  //   const testPassword = validatePassword(new_password)
  //   if (!testPassword.isValid) {
  //     failForm(testPassword.message, toast)
  //     return {
  //       isValid: false,
  //       message: testPassword.message
  //     }
  //   }
  // }
  if (new_email_address && new_email_address !== savedUserDetails?.email_address && new_email_address !== "") {
    const confirmEmailChange = window.confirm(
      `Email address will be changed only after clicking on the confirmation link sent to ${new_email_address}. Until then ${savedUserDetails?.email_address} will continue to work.`
    )
    if (!confirmEmailChange) {
      return {
        isValid: false,
        message: "Please confirm the email address change"
      }
    }
  }
  if (new_email_address === savedUserDetails?.email_address) {
    failForm("New email address cannot be the same as the existing email address.", toast)
    return {
      isValid: false,
      message: "New email address cannot be the same as the existing email address."
    }
  }
  return {
    isValid: true,
    message: ""
  }
}
